import { useWorkflow } from "../workflow-context";

import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";

const useAllSources = (): Record<SourceType, string[]> => {
  const workflow = useWorkflow();
  const { input_variables, nodes, activeNodeId } = workflow;

  // Get all node names as potential dependencies, not just linked ones
  const allDependencies = nodes
    .filter(node => node.id !== activeNodeId)
    .map(node => workflow.getNodeName(node.id));

  return {
    [SourceType.InputVariable]: input_variables.map(v => v.key),
    [SourceType.Column]: [],
    [SourceType.Dataset]: [],
    [SourceType.Dependency]: allDependencies,
  };
};

export default useAllSources;
